import { DevTools, Tolgee, BackendFetch, LanguageDetector } from "@tolgee/web";
import { FormatIcu } from "@tolgee/format-icu";
import { env } from "@copilot/config/env";

const apiKey = env.TOLGEE_API_KEY;
const apiUrl = env.TOLGEE_API_URL;

export const ALL_LANGUAGES = ["en", "de-DE", "fr-FR", "es-ES"];

export const DEFAULT_LANGUAGE = "en";

export function TolgeeBase() {
  const base = Tolgee()
    .use(FormatIcu())
    .use(DevTools())
    .use(LanguageDetector());

  return (
    env.TOLGEE_CDN_PREFIX_URL
      ? base.use(
          BackendFetch({
            prefix: env.TOLGEE_CDN_PREFIX_URL,
          }),
        )
      : base
  ).updateDefaults({
    apiKey,
    apiUrl,
    defaultLanguage: DEFAULT_LANGUAGE,
    availableLanguages: ALL_LANGUAGES,
  });
}
